import "./PageLoader.scss";

interface IPageLoader {
    // розмір кільця: xs 20px, sm 28px, md 40px, lg 56px
    size?: "xs" | "sm" | "md" | "lg";
    // true: напівпрозорий шар на весь найближчий позиціонований блок (як у rsuite Loader)
    backdrop?: boolean;
    // true: шар на весь екран (під навбаром), для початкового завантаження сайту
    fullscreen?: boolean;
    // підпис під кільцем
    label?: string;
}

// Єдиний лоадер сайту. З'являється з невеликою затримкою (CSS), тож на швидких відповідях не мигає.
const PageLoader = ({ size = "md", backdrop = false, fullscreen = false, label }: IPageLoader) => {
    const classes = [
        "page-loader",
        `page-loader-${size}`,
        backdrop || fullscreen ? "page-loader-backdrop" : "",
        fullscreen ? "page-loader-fullscreen" : "",
    ].filter(Boolean).join(" ");

    return (
        <div className={classes} role="status" aria-live="polite" aria-label={label ?? "Завантаження"}>
            <div className="page-loader-content">
                <div className="page-loader-ring-wrap">
                    <span className="page-loader-ring" />
                    <span className="page-loader-core" />
                </div>
                { label && <div className="page-loader-label">{label}</div> }
            </div>
        </div>
    );
};

export default PageLoader;
